export const getComments = async () => {
  return [
    {
      id: "1",
      body: "What is Autism",
      username: "Mithila",
      userId: "1",
      parentId: null,
      createdAt: "2022-10-16T23:00:33.010+02:00",
    },
    {
      id: "2",
      body: "What is the symbol of autism",
      username: "Rakib",
      userId: "2",
      parentId: null,
      createdAt: "2022-09-16T23:00:33.010+02:00",
    },
    {
      id: "3",
      body: "Autism spectrum disorder (ASD) is a developmental disability caused by differences in the brain.",
      username: "Utsho",
      userId: "2",
      parentId: "1",
      createdAt: "2022-10-16T23:00:33.010+02:00",
    },
    {
      id: "4",
      body: "The puzzle ribbon was adopted in 1999 as the universal sign of autism awareness.",
      username: "Fahim",
      userId: "2",
      parentId: "2",
      createdAt: "2022-09-16T23:00:33.010+02:00",
    },
  ];
};

export const createComment = async (text, parentId = null) => {
  return {
    id: Math.random().toString(36).substr(2, 9),
    body: text,
    parentId,
    userId: "1",
    username: localStorage.getItem("username"),
    createdAt: new Date().toISOString(),
  };
};

export const updateComment = async (text) => {
  return { text };
};

export const deleteComment = async () => {
  return {};
};
